import { ReactComponent as LogoWithText } from '../../icons/svg/logoWithText.svg';
import { ReactComponent as LogoTextOnly } from '../../icons/svg/LogoTextOnly.svg';

interface Props {
  className?: string;
  onClick?: () => void;
  noIcon?: boolean;
}

const Logo = ({ className = '', onClick, noIcon }: Props) => {
  if (noIcon) {
    return (
      <LogoTextOnly
        className={className + ' hover:cursor-pointer'}
        onClick={onClick}
        width={120}
      />
    );
  }
  return (
    <LogoWithText
      className={className + ' hover:cursor-pointer'}
      onClick={onClick}
      width={120}
      height={50}
    />
  );
};

export default Logo;
